import NextjsInactive from './nextjs-inactive';

export default NextjsInactive;
